module.exports = __webpack_public_path__ + "static/media/rs-in.7922d53c.svg";